/*
export const myAction = async ({comit}) => {

}
*/

import appApi from "@/api/appApi"

export const loadPointScore = async ({commit}, meet_id) => {
    const date=new Date().getTime()
    const response = await fetch(`https://live.swimrankings.net/meets/${meet_id}/main.json?t=${date}`,)
    const data = await response.json()
    if(data.pointscores) {
        const lstPoints = await Promise.all(
            data.pointscores.map(async (pointscore) => {
                const r = await fetch(`https://live.swimrankings.net/meets/${meet_id}/pointscores/${pointscore.id}.json?t=${date}`)
                const dataPoint = await r.json()
                return { id: pointscore.id, name: pointscore.name, categories: dataPoint.categories, status: data.status }
            })
        )
        commit('setPointScore', lstPoints)
    } else {
        commit('setPointScore', [])
    }
}

export const loadCompetitions = async ({ commit }) => {
    commit('setFederation', process.env.VUE_APP_FED_ID)
    const resp = await appApi.post('/eventos', {
        fed_id: process.env.VUE_APP_FED_ID,
        type: 'all'
    })
    const date = new Date().getTime()
    const competitions = await Promise.all(
        resp.data.data.map(async (meet) => {
            const response = await fetch(`https://live.swimrankings.net/meets/${meet.meet_id}/main.json?t=${date}`)
            const data = await response.json()
            const { status_name, status_class } = getEstadoCompeticion(data.status)
            return {
                meet_id: meet.meet_id,
                name: data.name,
                course: (data.course == 1) ? '50m' : '25m',
                city: data.city,
                days: `${data.days} dia(s)`,
                statistic_entries: data.statistic.entries,
                statistic_relays: data.statistic.relays,
                statistic_athletes: data.statistic.athletes,
                startdate: data.startdate,
                enddate: data.enddate,
                status: data.status,
                status_name,
                status_class
            }
        })
    )
    commit('setCompetitions', competitions)
}

const getAgregroupName = (agegroups, id) => {
    const agegroup = agegroups.find(age => age.id == id)
    if(!agegroup) return ``
    return {...agegroup}
}

const difTimeEntryResult = (entrytime, swimtime) => {
    let totalSegsEntry = 0
    let totalSegsSwim = 0

    let totalTimeEntry = 0;
    let totalTimeSwim = 0;

    const h1 = entrytime.split(':')
    if(h1.length > 1) {
        const m1 = h1[1].split('.')
        totalSegsEntry = (parseInt(h1[0]) * 60 * 60) + (parseInt(m1[0]))
        totalTimeEntry = `${totalSegsEntry}.${m1[1]}`
    } else {
        const m1 = entrytime.split('.')
        totalSegsEntry = (parseInt(m1[0])) 
        totalTimeEntry = `${totalSegsEntry}.${m1[1]}`
    }

    const h2 = swimtime.split(':')
    if(h2.length > 1) {
        const m2 = h2[1].split('.')
        totalSegsSwim += (parseInt(h2[0]) * 60 * 60) + (parseInt(m2[0]))
        totalTimeSwim = `${totalSegsSwim}.${m2[1]}`
    } else {
        const m2 = swimtime.split('.')
        totalSegsSwim += (parseInt(m2[0])) 
        totalTimeSwim = `${totalSegsSwim}.${m2[1]}`
    }

    const segs = Math.round((parseFloat(totalTimeSwim) - parseFloat(totalTimeEntry))*100) / 100

    return segs
}

const getEstadoCompeticion = (status) => {
    switch(status) {
        case 1: case 2: return { status_name: 'SIN EMPEZAR', status_class: 'badge-success' }
        case 3:         return { status_name: 'EN CURSO',    status_class: 'badge-danger' }
        case 5:         return { status_name: 'FINALIZADA',  status_class: 'badge-primary' }
        default:        return { status_name: 'FINALIZADA',  status_class: 'badge-primary' }
    }
}

const getEstadoEvento = (status) => {
    switch(status) {
        case 0: return { estado: 'SIN SORTEAR', estado_class: 'badge-warning' }
        case 1: return { estado: 'SIN EMPEZAR', estado_class: 'badge-warning' }
        case 2: return { estado: 'SIN EMPEZAR', estado_class: 'badge-success' }
        case 3: return { estado: 'EN CURSO',    estado_class: 'badge-danger' }
        case 5: return { estado: 'FINALIZADA',  estado_class: 'badge-primary' }
        default: return { estado: '',           estado_class: '' }
    }
}

const getRoundName = (round) => {
    switch(round) {
        case '1': return 'Final Contra Reloj'
        case '2': return 'Preliminar'
        case '9': return 'Final'
        case '8': return 'Serie rápida'
        default:  return ''
    }
}

const getStroke = (stroke) => {
    switch (stroke) {
        case "1": return 'Libre'
        case "2": return 'Espalda'
        case "3": return 'Braza'
        case "4": return 'Mariposa'
        case "5": return 'Estilos'
        default: return 'N/D'
    }
}

const getGender = (gender) => {
    switch (gender) {
        case "1": return 'Masculino'
        case "11": return 'Masculino'
        case "2": return 'Femenino'
        case "12": return 'Femenino'
        case "3": return 'Mixto'
        case "0": return 'Mixto'
        default: 'N/D'
    }
}

export const loadEntries = async ({ commit }, datos) => {
    const date=new Date().getTime()
    const response = await fetch(`https://live.swimrankings.net/meets/${datos.meet_id}/entries/${datos.event_id}.json?t=${date}`)
    const data = await response.json()
    //const { data } = await swimRankingsApi.get(`/${datos.meet_id}/entries/${datos.event_id}.json`, { cache: false })
    if (!data) {
        commit('setEntries', [])
        commit('setEventId', null)
        commit('setRelay', false)
        return
    }
    const { entries, agegroups } = data;
    let newEntries = []
    //Si son finales, en el TICC salía de otra manera
    //Modificado 09/12/2024
    if(agegroups) {
        console.log(agegroups);
        for(const agegroup of agegroups) {
            for (const entry of agegroup.entries) {
                newEntries.push({
                    ...entry,
                    isrelay: datos.isrelay
                })
            }
        }
    } else {
        if(entries) {
            for (const entry of entries) {
                newEntries.push({
                    ...entry,
                    isrelay: datos.isrelay
                })
            }
        }
    }


    commit('setEventId', datos.event_id)
    commit('setEntries', newEntries)
    commit('setRelay', datos.isrelay)
}

export const loadEventsClub = async ({ commit }, meet_id) => {
    commit('isLoadingEntries', true)
    const date=new Date().getTime()
    const response = await fetch(`https://live.swimrankings.net/meets/${meet_id}/events.json?t=${date}`)
    const data = await response.json()
    const filteredEvents = Object.values(data).filter(ev => ev.number > 0)
    const events = await Promise.all(
        filteredEvents.map(async (ev) => {
            const r = await fetch(`https://live.swimrankings.net/meets/${meet_id}/entries/${ev.id}.json?t=${date}`)
            const dataEntrie = await r.json()
            return {
                id: ev.id,
                number: ev.number,
                distance: ev.distance,
                stroke: getStroke(ev.stroke),
                gender: getGender(ev.gender),
                gender_raw: ev.gender,
                prueba: `${ev.distance} ${getStroke(ev.stroke)} ${getGender(ev.gender)}`,
                date: ev.date,
                time: ev.time,
                isrelay: ev.isrelay,
                round: getRoundName(ev.round),
                round_raw: ev.round,
                selected: false,
                entries: dataEntrie.entries
            }
        })
    )
    commit('setEvents', events)
    commit('isLoadingEntries', false)
}

export const loadEventsClub2 = async ({ commit }, meet_id) => {
    commit('isLoadingEntries', true)
    const date=new Date().getTime()
    const response = await fetch(`https://live.swimrankings.net/meets/${meet_id}/events.json?t=${date}`)
    const data = await response.json()
    const filteredEvents = Object.values(data).filter(ev => ev.number > 0)
    const events = await Promise.all(
        filteredEvents.map(async (ev) => {
            const r = await fetch(`https://live.swimrankings.net/meets/${meet_id}/entries/${ev.id}.json?t=${date}`)
            const dataEntrie = await r.json()
            return {
                id: ev.id,
                number: ev.number,
                distance: ev.distance,
                stroke: getStroke(ev.stroke),
                gender: getGender(ev.gender),
                gender_raw: ev.gender,
                prueba: `${ev.distance} ${getStroke(ev.stroke)} ${getGender(ev.gender)}`,
                date: ev.date,
                time: ev.time,
                isrelay: ev.isrelay,
                round: getRoundName(ev.round),
                round_raw: ev.round,
                selected: false,
                entries: dataEntrie.entries
            }
        })
    )
    commit('setEvents2', events)
    commit('isLoadingEntries', false)
}

export const loadEvents = async ({ commit }, meet_id) => {
    commit('setLoading', true)
    commit('setHeats', [])
    commit('setEntries', [])
    const date=new Date().getTime()
    const response = await fetch(`https://live.swimrankings.net/meets/${meet_id}/events.json?t=${date}`)
    const data = await response.json()
    const filteredEvents = Object.values(data).filter(ev => ev.number > 0)
    const events = await Promise.all(
        filteredEvents.map(async (ev) => {
            const r = await fetch(`https://live.swimrankings.net/meets/${meet_id}/results/${ev.id}.json?t=${date}`)
            const dataResult = await r.json()
            const { estado, estado_class } = getEstadoEvento(dataResult.status)
            return {
                id: ev.id,
                number: ev.number,
                distance: ev.distance,
                stroke: getStroke(ev.stroke),
                gender: getGender(ev.gender),
                date: ev.date,
                time: ev.time,
                isrelay: ev.isrelay,
                round: getRoundName(ev.round),
                round_raw: ev.round,
                selected: false,
                search: `${ev.distance} ${getStroke(ev.stroke)} ${getGender(ev.gender)}`,
                estado,
                estado_class
            }
        })
    )
    commit('setEvents', events)
    commit('setLoading', false)
}

export const loadHeats = async ({ commit }, datos) => {
    const date=new Date().getTime()
    const response = await fetch(`https://live.swimrankings.net/meets/${datos.meet_id}/heats/${datos.event_id}.json?t=${date}`)
    const data = await response.json()
    //const { data } = await swimRankingsApi.get(`/${datos.meet_id}/heats/${datos.event_id}.json`, { cache: false })
    if (!data) {
        commit('setHeats', [])
        commit('setEventId', null)
        return
    }

    const { heats } = data;
    let newHeats = []
    for (const heat of heats) {
        newHeats.push({
            ...heat,
            isrelay: datos.isrelay
        })
    }
    commit('setEventId', datos.event_id)
    commit('setHeats', newHeats)
}

export const loadResults = async ({ commit, state }, datos) => {
    const date=new Date().getTime()
    const response = await fetch(`https://live.swimrankings.net/meets/${datos.meet_id}/results/${datos.event_id}.json?t=${date}`)
    const data = await response.json()
    //const { data } = await swimRankingsApi.get(`/${datos.meet_id}/results/${datos.event_id}.json`, { cache: false })
    if (!data) {
        commit('setResults', [])
        return
    }

    let resultsArr = []

    let estado = ''
    let estado_class = ''
    if(data.status == 5) {
        estado = 'RESULTADOS OFICIALES'
        estado_class = 'badge-primary'
    } else {
        estado = 'RESULTADOS PROVISIONALES'
        estado_class = 'badge-danger'
    }

    const agegroups = state.agegroups
    for(const agegroup of data.agegroups) {
        const agegroupName = getAgregroupName(agegroups, agegroup.id)
        let resultsArr2 = []
        for(const r of agegroup.results) {
            let place = r.place
            if(r.place < 0) {
                if(r.entrystatus) {
                    place = r.entrystatus
                } else {
                    place = 'DSQ'
                }
            }
            let diff_time = ''
            if(r.diff) {
                diff_time = r.diff
            }
            let medal_class = ''
            if(r.medal) {
                switch(r.medal) {
                    case 1: 
                        medal_class='gold' 
                        break
                    case 2: 
                        medal_class='silver' 
                        break
                    case 3: 
                        medal_class='bronze' 
                        break
                }
            }

            let diffEntrySwim = ''

            if((r.swimtime != '') && (r.entrytime != '')) {
                diffEntrySwim = difTimeEntryResult(r.entrytime, r.swimtime)
            }
           
            let arrSplits = []
            if(r.splits) {
                for(let clave in r.splits) {
                    const times = r.splits[clave].split(' ')
                    //console.log(times)
                    arrSplits.push({
                        meters: clave,
                        split_time: times[0],
                        partial: times[2]
                    })
                }
            }
            resultsArr2.push({
                isrelay: datos.isrelay,
                place_name: place,
                diff_time,
                medal_class,
                diff_entry: diffEntrySwim,
                splits_arr: arrSplits,
                ...r
            })
        }
        const result = {
            id: agegroup.id,
            name: agegroupName.name,
            estado,
            estado_class,
            results: resultsArr2
        }
        resultsArr.push(result)
    }

    commit('setResults', resultsArr)
}

export const loadMain = async ({ commit }, meet_id) => {
    const date=new Date().getTime()
    const response = await fetch(`https://live.swimrankings.net/meets/${meet_id}/main.json?t=${date}`,)
    const data = await response.json()
    //const { data } = await swimRankingsApi.get(`/${meet_id}/main.json`, { cache: false })
    if (!data) {
        commit('setMain', [])
        return
    }

    commit('setMain', data)
}

export const loadClubs = async ({commit}, meet_id) => {
    const date=new Date().getTime()
    const response = await fetch(`https://live.swimrankings.net/meets/${meet_id}/clubs.json?t=${date}`,)
    const data = await response.json()
    //const { data } = await swimRankingsApi.get(`/${meet_id}/main.json`, { cache: false })
    if (!data) {
        commit('setClubs', [])
        return
    }

    commit('setClubs', data)
}

export const loadAthletes = async ({commit}, meet_id) => {
    const date=new Date().getTime()
    const response = await fetch(`https://live.swimrankings.net/meets/${meet_id}/athletes.json?t=${date}`,)
    const data = await response.json()
    //const { data } = await swimRankingsApi.get(`/${meet_id}/main.json`, { cache: false })
    if (!data) {
        commit('setAthletes', [])
        return
    }

    commit('setAthletes', data)
}

export const loadSessions = async ({commit}, meet_id) => {
    const date=new Date().getTime()
    const response = await fetch(`https://live.swimrankings.net/meets/${meet_id}/eventsBySession.json?t=${date}`,)
    const data = await response.json()
    //const { data } = await swimRankingsApi.get(`/${meet_id}/main.json`, { cache: false })
    if (!data) {
        commit('setSessions', [])
        return
    }

    commit('setSessions', data.sessions)
}

export const loadAgeGroups = async ({ commit }, meet_id) => {
    const date=new Date().getTime()
    const response = await fetch(`https://live.swimrankings.net/meets/${meet_id}/agegroups.json?t=${date}`,)
    const data = await response.json()
    //const { data } = await swimRankingsApi.get(`/${meet_id}/agegroups.json`, { cache: false })
    let agegroups = []
    for (let clave in data) {
        const agegroup = {
            id: data[clave].id,
            name: data[clave].name
        }

        agegroups.push(agegroup)
    }
    commit('setAgegroups', agegroups)
}

export const loadEntriesAthlete = async ({commit, state}, data) => {
    const date=new Date().getTime()
    const eventosConAtleta = []
    for(const ev of state.events) {
        if(ev.entries) {
            const entry = ev.entries.find(e => e.athleteid == data.athleteid)
            if(entry) eventosConAtleta.push({ ev, entry })
        }
    }
    const resultados = await Promise.all(
        eventosConAtleta.map(async ({ ev, entry }) => {
            const response = await fetch(`https://live.swimrankings.net/meets/${data.meet_id}/heats/${ev.id}.json?t=${date}`)
            const dataHeat = await response.json()
            const items = []
            if(dataHeat.heats.length >= 1) {
                for(const heat of dataHeat.heats) {
                    for(const e of heat.entries) {
                        if(e.athleteid == data.athleteid) {
                            items.push({ evento: ev, status: heat.status, serie: heat.heatinfo.code, calle: e.lane, ...e })
                        }
                    }
                }
            } else {
                items.push({ evento: ev, status: 1, serie: null, calle: null, ...entry })
            }
            return items
        })
    )
    commit('setEventsAthlete', resultados.flat())
}

export const loadEntriesAthlete2 = async ({commit, state}, data) => {
    const date=new Date().getTime()
    const eventosConAtleta = []
    for(const ev of state.eventsclub) {
        if(ev.entries) {
            const entry = ev.entries.find(e => e.athleteid == data.athleteid)
            if(entry) eventosConAtleta.push({ ev, entry })
        }
    }
    const resultados = await Promise.all(
        eventosConAtleta.map(async ({ ev, entry }) => {
            const response = await fetch(`https://live.swimrankings.net/meets/${data.meet_id}/heats/${ev.id}.json?t=${date}`)
            const dataHeat = await response.json()
            const items = []
            if(dataHeat.heats.length >= 1) {
                for(const heat of dataHeat.heats) {
                    for(const e of heat.entries) {
                        if(e.athleteid == data.athleteid) {
                            items.push({ evento: ev, status: heat.status, serie: heat.heatinfo.code, calle: e.lane, ...e })
                        }
                    }
                }
            } else {
                items.push({ evento: ev, status: 1, serie: null, calle: null, ...entry })
            }
            return items
        })
    )
    commit('setEventsAthlete', resultados.flat())
}
